<template>
  <el-dialog
    title="推荐专业排序"
    :visible.sync="dialogVisible"
    append-to-body
    top="2vh"
    fullscreen
    width="80%" v-loading="loading">
    <div class="list_aa">
      <draggable v-model="list" @end="end" :prevent-default="false">
        <div v-for="(item, i) in list" :key="i" class="list">
          <div class="lists">
            <div class="xuhao">
              {{ i + 1 }}
            </div>
            <div class="checkds">
              <el-checkbox v-model="item.checkd"></el-checkbox>
            </div>
            <div
            class="biaotous bgn"
            :style="{ width: '1137px'}"
            style="justify-content: flex-start;background: #fff!important;">
            <div class="">
              <div class="d-inline-block" style="display: flex;align-items: center;">
                <div class="text-danger text-decoration-none">
                  <span style="font-size: 160%;cursor: pointer;color: #f3545d;" @click="collegeClick(item)">
                    {{ item.collegeName }}
                    <span v-if="item.collegeNameRemark">
                      {{ item.collegeNameRemark }}
                    </span>
                    [{{ item.collegeNature }}]
                      {{ item.specialty_title }}
                  </span>
                </div>
                <span class="text-muted mr-3" style="font-size: 16px">
                <span v-if="item.collegeProvince">{{
                  item.collegeProvince
                }}</span>
                <span v-if="item.collegeCity">,{{ item.collegeCity }}</span>
                <span v-if="item.collegeLevel">,{{ item.collegeLevel }}</span>
              </span>
              <el-tag
                size="mini"
                type="danger"
                style="margin-left: 5px"
                v-if="item.is985 == '是'"
                >985</el-tag
              >
              <el-tag
                size="mini"
                type="danger"
                style="margin-left: 5px"
                v-if="item.is211 == '是'"
                >211</el-tag
              >
              <el-tag
                size="mini"
                type="danger"
                style="margin-left: 5px"
                v-if="item.two_yiliu == '是'"
                >双一流</el-tag
              >
              <el-tag size="mini" style="margin-left: 5px">{{
                item.collegeNature
              }}</el-tag>
              <el-tag size="mini" type="danger" style="margin-left: 5px">{{
                item.collegeType
              }}</el-tag>
              <el-tag
                size="mini"
                v-if="item.isGuo"
                type="danger"
                style="margin-left: 5px"
              >
                {{ item.isGuo }}
              </el-tag>
              <el-badge
                value="硕"
                type="warning"
                class="item"
                v-if="item.shuoshiNum"
              ></el-badge>
              <el-badge
                value="博"
                type="danger"
                class="item"
                v-if="item.boshiNum"
              ></el-badge>
              <el-badge
                value="保"
                type="success"
                class="item"
                v-if="item.isBao == 1"
              ></el-badge>
              </div>
              <div class="text-dark" style="font-size: 120%;margin-top: 10px;">
                <span
                  class="d-inline-block text-truncate w-100 might-overflow"
                  style="display: flex; align-items: center">
                  <div
                    class="text-primary text-decoration-none"
                    style="display: flex; align-items: center;cursor: pointer;" @click="majorDetail(item)">
                    {{ item.specialty_title }}
                    <span v-if="item.major_field">{{ item.major_field }}</span>
                  </div>
                  
                <div>
                  <el-tag
                          size="mini"
                          type="danger"
                          style="margin-left: 5px"
                          v-if="
                            !item.current_year_red_score &&
                            !item.qu_year_red_score &&
                            !item.qian_year_red_score
                          ">
                          新专业
                        </el-tag>
                </div>
                <div>
                  <el-tag
                          size="mini"
                          style="margin-left: 5px"
                          v-if="item.cengci"
                          >
                          {{item.cengci.includes('职')?'职业教育':item.cengci}}
                        </el-tag>
                </div>
                <!-- <div>
                  <el-tag
                          size="mini"
                          type="danger"
                          style="margin-left: 5px"
                          v-if="
                            item.collegeNameRemark&&item.collegeNameRemark.includes('新更名')
                          ">
                          新更名
                        </el-tag>
                </div> -->
                  <span style="margin-left: 15px;">
                    学制：{{ item.schooling_length }},学费：{{ item.tuition_fee==-1?"待定":item.tuition_fee }},专业代码：{{ item.specialty_code }};
                  </span>
                </span>
              </div>
              <div class="info">
                  分数：{{ item.yugu_score }}
                  <div style="margin-left: 20px">
                    学校排名：{{ item.ruan_pai }}
                  </div>
                  <div style="margin-left: 20px">
                    专业排名：{{ majorReturn(item) }}
                    <span v-if="item.soft_ranking">
                      ，{{ item.soft_ranking || "--" }}
                    </span>
                  </div>
                  <div style="margin-left: 20px" v-if="item.major_field">
                    专业方向：{{ item.major_field }}
                  </div>
                </div>
              <div class="info" v-if="item.major_remark">
                专业简注：{{ item.major_remark }}
              </div>
            </div>
          </div>

            <div style="margin-left: auto">
              <i class="el-icon-rank" style="font-size: 25px"></i>
            </div>
          </div>
        </div>
      </draggable>
    </div>
    <span
      slot="footer"
      class="dialog-footer"
      style="display: flex; align-items: flex-start; justify-content: center">
      <el-button type="success" @click="quxiao()">取消选择</el-button>
      <div
        style="
          display: flex;
          align-items: center;
          color: #666;
          font-size: 16px;
          margin-left: 20px;
        ">
        将选中专业移到
        <el-input
          v-model="sort"
          type="number"
          style="
            width: 100px;
            margin-left: 10px;
            margin-right: 10px;
          "></el-input>
        号专业之前
      </div>
      <el-button
        type="primary"
        style="margin-left: 20px"
        @click="kaishiyidong(sort)">
        开始移动
      </el-button>
      <el-button type="danger" style="margin-left: 20px" @click="zidongpaixu">
        自动排序
      </el-button>
      <div style="margin-left: auto">
        <el-button type="success" @click="updateAll()">保存</el-button>
        <el-button type="danger" @click="dialogVisible = false">
          取消并关闭
        </el-button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import { updateAll } from "@/api/gw/volunteerresult.js";
import draggable from "vuedraggable";
export default {
  components: {
    draggable,
  },
  data() {
    return {
      dialogVisible: false,
      sort: "",
      loading:false,
      list:[],
    };
  },
  props: {
    lists: {
      type: Array,
      default: [],
    },
    dialogVisible(e){
      if(e==false){
        this.list.forEach(r=>{
          r.checkd = false
        })
      }
    },
  },
  watch: {
    lists(e){
      this.list = e
    }
  },
  methods: {
    updateAll(){
      this.loading = true
      let arr = [];
      this.list.forEach((r, j) => {
        arr.push({
          volunteer_result_id: r.volunteer_result_id,
          sort_id: Number(j + 1),
        });
      });
      updateAll({
        list: arr,
      }).then(()=>{
        this.$notify({
        title: "信息",
        message: "保存成功",
        type: "success",
      });
      this.dialogVisible = false
      this.$parent.college_result_screen();
      }).finally(()=>{
        this.loading = false
      })
    },
    //自动排序
    zidongpaixu() {
      let that = this;
      this.list.sort(function (a, b) {
        return b.yugu_score - a.yugu_score;
      });
      this.$notify({
        title: "信息",
        message: "已完成对所有专业的排序",
        type: "success",
      });
    },
    //开始移动
    kaishiyidong(newIndex) {
      let list = this.list.filter((r) => {
        return r.checkd;
      });
      if (list.length == 0) {
        this.$notify({
          title: "信息",
          message: "请确保至少选中一个专业",
          type: "error",
        });
        return;
      }
      if (!this.sort) {
        this.$notify({
          title: "信息",
          message: "请输入移动到哪个序号之前",
          type: "success",
        });
        return;
      }
      let lists = [...this.list];
      let selectedIndices = [];
      lists.forEach((r,j)=>{
        if(r.checkd){
          selectedIndices.push(j)
        }
      })
      const selectedItems = selectedIndices.map(index => lists[index]);
      this.list = lists.filter((_, index) => !selectedIndices.includes(index));
      this.list.splice(this.sort-1, 0, ...selectedItems);
      selectedIndices = [];
      this.list.forEach(r=>{
        r.checkd = false
      })
    },
    //取消选择
    quxiao() {
      this.list.forEach((r) => {
        this.$set(r, "checkd", false);
      });
      this.$notify({
        title: "信息",
        message: "已取消对所有专业的选择",
        type: "success",
      });
    },
    end(event) {
          //获取新的顺序
      let list = [...this.list];
      const newOrder = list.map((item, index) => ({
        ...item,
        position: index,
      }));
      this.list = newOrder;
    },
    //检测专业是A+还是其他
    majorReturn(item) {
      if (item.ajia_major && item.ajia_major.includes(item.majors)) {
        return "A+";
      } else if (item.as_major && item.as_major.includes(item.majors)) {
        return "A";
      } else if (item.a_jian_major && item.a_jian_major.includes(item.majors)) {
        return "A-";
      } else if (item.b_jia_major && item.b_jia_major.includes(item.majors)) {
        return "B+";
      } else if (item.b_majors && item.b_majors.includes(item.majors)) {
        return "B";
      } else if (item.b_jian_major && item.b_jian_major.includes(item.majors)) {
        return "B-";
      } else if (item.c_jia_major && item.c_jia_major.includes(item.majors)) {
        return "C+";
      } else if (item.c_major && item.c_major.includes(item.majors)) {
        return "C";
      } else if (item.c_jian_major && item.c_jian_major.includes(item.majors)) {
        return "C-";
      } else {
        return "无";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.list_aa{
  width: 100%;height: 86vh;overflow-y: auto;background: #f9fbfd;
}
.info {
  font-size: 16px;
  color: #6c757d;
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
}
.name {
  color: #f3545d;
  font-size: 18px;
  font-weight: bold;
  display: flex;
  align-content: center;
  .names {
    color: #177dff;
  }
}
.list {
  width: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
  background: #fff;
  border-bottom: 1px solid #ececec;
  .lists {
    width: 95%;
    margin: 0 auto;
    display: flex;
    align-items: center;
  }
  .xuhao {
    width: 50px;
    font-size: 20px;
    font-weight: bold;
    color: #409eff;
  }
}
.checkds {
  margin-left: 20px;
}
::v-deep .el-checkbox__inner {
  width: 20px !important;
  height: 20px !important;
}
::v-deep .el-dialog__body {
  padding: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/volunteer/sort.vue